export const createPendingReportWindow = () => {
  const reportWindow = window.open('', '_blank')

  if (reportWindow) {
    reportWindow.document.write(`
      <html>
        <head>
          <title>Generando reporte...</title>
        </head>
        <body style="font-family: Arial, sans-serif; display:flex; align-items:center; justify-content:center; min-height:100vh; margin:0; color:#2D749C;">
          <div>Generando reporte...</div>
        </body>
      </html>
    `)
    reportWindow.document.close()
  }

  return reportWindow
}

const dataUrlToObjectUrl = async (url: string) => {
  const response = await fetch(url)
  const blob = await response.blob()
  return URL.createObjectURL(blob)
}

export const openReportInWindow = async (
  reportWindow: Window | null,
  url?: string,
) => {
  if (!url) {
    throw new Error('No se recibió la URL del reporte')
  }

  const navigableUrl = url.startsWith('data:application/pdf')
    ? await dataUrlToObjectUrl(url)
    : url

  if (reportWindow) {
    reportWindow.location.href = navigableUrl
    return
  }

  const fallbackWindow = window.open(
    navigableUrl,
    '_blank',
  )

  if (!fallbackWindow) {
    throw new Error(
      'El navegador bloqueó la apertura del reporte en una nueva pestaña',
    )
  }
}

export const closeReportWindow = (
  reportWindow: Window | null,
) => {
  try {
    reportWindow?.close()
  } catch (error) {
    console.error('No se pudo cerrar la ventana del reporte', error)
  }
}
